/* eslint-disable no-undef */
import Vue from 'vue'
import { hasClass } from '@/assets/js/dom'
import { showSoftInput } from '@/assets/js/native'

const focus = Vue.directive('focus', {
  inserted: function (el, o) {    // 第二个参数传进来的是个json
    if (o.value) {
      if (hasClass(el, 'el-input')) {
        let input = el.getElementsByTagName('INPUT')
        if (input) {
          input = input[0]
          setTimeout(() => {
            showSoftInput()
            setTimeout(() => {
              input.focus()
            }, 200)
          }, 100)
        }
      } else {
        setTimeout(() => {
          showSoftInput()
          setTimeout(() => {
            el.focus()
          }, 200)
        }, 100)
      }
    }
  }
})

export { focus }



// WEBPACK FOOTER //
// ./src/assets/js/vueDirect.js